import L from 'leaflet';
import { ZIPCODE_MAP_CUSTOMER_DOT, ZIPCODE_MAP_STORE_DOT } from './zipcodeMapConfig';

const DOT_SIZE = 12;

/** GeoJSON Point coordinates are [lng, lat]. Leaflet uses [lat, lng]. */
export function latLngFromGeolocation(geolocation) {
  const coords = geolocation?.coordinates;
  if (!Array.isArray(coords) || coords.length < 2) return null;
  const lng = Number(coords[0]);
  const lat = Number(coords[1]);
  if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;
  return [lat, lng];
}

/** All customers/stores across every zip in branch analytics. */
export function extractZipcodeAnalyticsMarkers(analyticsData) {
  const customers = [];
  const stores = [];

  for (const row of analyticsData?.zipcodes ?? []) {
    const zip = String(row?.zipcode ?? '').trim();
    if (!zip) continue;

    for (const customer of row.customers ?? []) {
      const position = latLngFromGeolocation(customer?.geolocation);
      if (!position) continue;
      customers.push({
        zip,
        position,
        name: customer.name,
        email: customer.email,
        address: customer.address,
      });
    }

    for (const store of row.stores ?? []) {
      const position = latLngFromGeolocation(store?.geolocation);
      if (!position) continue;
      stores.push({
        zip,
        position,
        name: store.name,
        email: store.email,
        address: store.address,
      });
    }
  }

  return { customers, stores };
}

export function createZipcodeMapDotIcon(color) {
  return L.divIcon({
    className: '',
    html: `<div style="width:${DOT_SIZE}px;height:${DOT_SIZE}px;border-radius:50%;background:${color};border:2px solid #fff;box-shadow:0 1px 4px rgba(0,0,0,0.35);box-sizing:border-box;"></div>`,
    iconSize: [DOT_SIZE, DOT_SIZE],
    iconAnchor: [DOT_SIZE / 2, DOT_SIZE / 2],
  });
}

export const customerDotIcon = createZipcodeMapDotIcon(ZIPCODE_MAP_CUSTOMER_DOT);
export const storeDotIcon = createZipcodeMapDotIcon(ZIPCODE_MAP_STORE_DOT);
